// Module
var code = `<app-deepdive-v2 *ngIf="changeLayoutDeepDive==1"></app-deepdive-v2> <app-deepdive-v1 *ngIf="changeLayoutDeepDive==0"></app-deepdive-v1>`;
// Exports
export default code;